/**
 * Storage key constants for localStorage and sessionStorage.
 * These keys are used across AuthModule and BrowserModule for managing
 * authentication state and persisted data.
 */

// localStorage keys
export const STORAGE_KEY_SERVICE_ID = 'serviceId';
export const STORAGE_KEY_SERVICE_NAME = 'serviceName';
export const STORAGE_KEY_REFRESHED_AT = 'refreshedAt';
export const STORAGE_KEY_TASKS = 'tasks';

/**
 * Severity ('critical' | 'warning') the user last dismissed the config-review banner at.
 * sessionStorage-backed so dismissal survives page reloads but resets on the next login.
 */
export const STORAGE_KEY_CONFIG_REVIEW_BANNER_DISMISSED =
  'config_review_banner_dismissed';

/**
 * Set once the user ticks "Don't show this again" on the resolve-voicemail
 * confirmation. Per browser, not per user — resolving must still work when
 * storage is unavailable, in which case the confirmation keeps showing.
 */
export const STORAGE_KEY_VOICEMAIL_RESOLVE_CONFIRMATION_SUPPRESSED =
  'voicemail_resolve_confirmation_suppressed';
